export const GEOLOCATION = {
  NOT_SUPPORTED: 'not_supported',
};
